import { render, staticRenderFns } from "./current-status.vue?vue&type=template&id=cef8b154&scoped=true&"
import script from "./current-status.vue?vue&type=script&lang=js&"
export * from "./current-status.vue?vue&type=script&lang=js&"
import style0 from "./current-status.vue?vue&type=style&index=0&id=cef8b154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef8b154",
  null
  
)

export default component.exports